/*
	This script defines the CRUD request functions for each component.
	
	The functions curry the Authorization token and use it to make requests to
	the backend of the client's application.
	
*/

import fetch from "isomorphic-unfetch"
import urlBeginning from "./urlConstructor"

const authToken = () => {
  const { cookie } = document
  return `Bearer ${cookie.split(".idToken=").pop().split(";").shift()}`
}

const makeRequest = ({
  url,
  method,
  onSuccess,
  onFailure,
  options,
  signal = null,
}) =>
  fetch(urlBeginning + url, {
    method,
    ...(method !== "GET" && {
      body: options.rawBody || JSON.stringify(options.body),
    }),
    headers: {
      Authorization: authToken(),
      ...(!options.formdata && { "Content-Type": "application/json" }),
    },
    signal,
  })
    .then(async (el) => {
      const { status } = el

      let data
      try {
        if (options.responseType === "arrayBuffer")
          data = await el.arrayBuffer()
        else data = await el.json()
      } catch {
        data = {}
      } finally {
        if (!data) data = {}
      }

      if (status < 400) onSuccess(data)
      else onFailure({ status, data, message: data.error?.message })
    })
    .catch(console.error)

export const makePostRequest = ({
  url,
  body,
  onSuccess,
  onFailure,
  options = {},
  signal = null,
}) =>
  makeRequest({
    url,
    method: "POST",
    onSuccess,
    onFailure,
    options: { ...options, body },
    signal,
  })

export const makeGetRequest = ({
  url,
  onSuccess,
  onFailure,
  options = {},
  signal = null,
}) =>
  makeRequest({
    url,
    method: "GET",
    onSuccess,
    onFailure,
    options,
    signal,
  })

export const makeDeleteRequest = ({
  url,
  body,
  onSuccess,
  onFailure,
  signal = null,
}) =>
  makeRequest({
    url,
    method: "DELETE",
    onSuccess,
    onFailure,
    options: { body },
    signal,
  })

export const makePutRequest = ({
  url,
  body,
  onSuccess,
  onFailure,
  signal = null,
}) =>
  makeRequest({
    url,
    method: "PUT",
    onSuccess,
    onFailure,
    options: { body },
    signal,
  })

export const makePatchRequest = ({
  url,
  body,
  onSuccess,
  onFailure,
  signal = null,
}) =>
  makeRequest({
    url,
    method: "PATCH",
    onSuccess,
    onFailure,
    options: { body },
    signal,
  })
